import resize_mixin from "~/mixins/resize"

export default {
  mixins: [resize_mixin],
  data: function () {
    return {
      id: this.makeid(),
      escapeEventHandler: null,
    }
  },
  mounted: function () {
    if (this.value) {
      this.listenEscape()
    }
    this.$on("close", () => {
      this.$emit("input", false)
    })
  },
  destroyed: function () {
    this.removeEscapeListen()
  },
  computed: {
    crossClass: function () {
      return {
        inverted: this.invert_close,
        white: this.inv_close_color,
      }
    },
  },
  methods: {
    close: function () {
      this.$emit("input", false)
      this.$emit("close")
    },
    listenEscape: function () {
      const vm = this

      if (this.escapeEventHandler === null) {
        this.escapeEventHandler = function (e) {
          if (vm.value && e.keyCode === 27) vm.close()
        }
        window.document.addEventListener("keydown", this.escapeEventHandler)
      }
    },
    removeEscapeListen: function () {
      if (this.escapeEventHandler !== null) {
        window.document.removeEventListener("keydown", this.escapeEventHandler)
        this.escapeEventHandler = null
      }
    },
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    compute_slot: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      },
    },
    overlayOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    transition: {
      type: String,
      required: false,
      default: function () {
        return "fade"
      },
    },
    has_close: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      },
    },
    invert_close: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      },
    },
    inv_close_color: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      },
    },
  },
  watch: {
    value: function () {
      if (!this.value) {
        this.removeEscapeListen()
      } else {
        this.computeAllResize()
        this.listenEscape()
      }
    },
  },
}
